export interface SearchResult {
  id: string;
  title: string;
  description: string;
  category: "page" | "section" | "blog" | "faq" | "service";
  url: string;
  keywords: string[];
}

export const searchIndex: SearchResult[] = [
  // Main Pages
  {
    id: "home",
    title: "Home",
    description: "Wave & Wire - Agency-grade websites without the agency price tag",
    category: "page",
    url: "/",
    keywords: ["home", "main", "wave wire", "web design", "hamptons"],
  },
  {
    id: "portfolio",
    title: "Portfolio",
    description: "View my work - custom websites built for businesses",
    category: "page",
    url: "/portfolio",
    keywords: ["portfolio", "work", "projects", "examples", "websites", "gallery"],
  },
  {
    id: "quote",
    title: "Get a Quote",
    description: "Request a free quote for your custom website project",
    category: "page",
    url: "/quote",
    keywords: ["quote", "pricing", "estimate", "cost", "free consultation", "contact"],
  },
  {
    id: "how-it-works",
    title: "How It Works",
    description: "Learn about my web design process - domains, hosting, and website building explained",
    category: "page",
    url: "/how-it-works-web-design-process",
    keywords: ["how it works", "process", "domain", "hosting", "website", "guide", "steps"],
  },
  {
    id: "blog",
    title: "Blog",
    description: "Web design tips, SEO strategies, and business insights for Hamptons entrepreneurs",
    category: "page",
    url: "/blog",
    keywords: ["blog", "articles", "tips", "insights", "news", "seo"],
  },

  // Homepage Sections
  {
    id: "about",
    title: "About Wave & Wire",
    description: "Learn about my mission to provide professional web design at fair prices",
    category: "section",
    url: "/#about",
    keywords: ["about", "who I am", "mission", "story", "aj grimaldi"],
  },
  {
    id: "pricing",
    title: "Pricing & Packages",
    description: "Transparent pricing - Landing Page from $1,000, Growth Site from $2,500, Custom Scale from $5,000",
    category: "section",
    url: "/#pricing",
    keywords: ["pricing", "packages", "cost", "rates", "landing page", "growth site", "custom", "1000", "2500", "5000"],
  },
  {
    id: "contact",
    title: "Contact Me",
    description: "Get in touch - Email: aj.grim94@gmail.com, Phone: (631) 707-0672",
    category: "section",
    url: "/#contact",
    keywords: ["contact", "email", "phone", "reach", "message", "get in touch"],
  },
  {
    id: "faq-section",
    title: "FAQ",
    description: "Frequently asked questions about my web design services",
    category: "section",
    url: "/#faq",
    keywords: ["faq", "questions", "answers", "help", "support"],
  },
  {
    id: "agency-trap",
    title: "The Agency Trap",
    description: "Learn about hidden agency fees and why you should own your website",
    category: "section",
    url: "/#about",
    keywords: ["agency trap", "hidden fees", "ownership", "free website", "monthly fees", "contracts"],
  },
  {
    id: "brand-identity",
    title: "Brand Identity Services",
    description: "Logo design, typography, and full brand identity creation",
    category: "service",
    url: "/#pricing",
    keywords: ["brand", "logo", "identity", "design", "typography", "favicon", "branding"],
  },

  // Hosting Options
  {
    id: "hosting-managed",
    title: "Managed Hosting",
    description: "Full service peace of mind - $75/month or $600/year with hosting, SSL, backups, and updates",
    category: "service",
    url: "/how-it-works-web-design-process#hosting",
    keywords: ["hosting", "managed", "monthly", "75", "600", "ssl", "backups", "updates", "peace of mind"],
  },
  {
    id: "hosting-diy",
    title: "Self-Managed Hosting",
    description: "DIY platform option - manage your own site with AI-powered editing tools",
    category: "service",
    url: "/how-it-works-web-design-process#hosting",
    keywords: ["self manage", "diy", "platform", "ai", "editing", "control"],
  },
  {
    id: "hosting-free",
    title: "Free Static Hosting",
    description: "The Freeze option - $0/month for static sites that don't need updates",
    category: "service",
    url: "/how-it-works-web-design-process#hosting",
    keywords: ["free", "static", "freeze", "zero", "no cost", "portfolio"],
  },

  // Blog Posts
  {
    id: "blog-hamptons-website",
    title: "Why Every Hamptons Business Needs a Professional Website",
    description: "In the competitive Hamptons market, a professional website is essential for success",
    category: "blog",
    url: "/blog/why-hamptons-businesses-need-professional-website",
    keywords: ["hamptons", "professional", "website", "business", "2025", "local"],
  },
  {
    id: "blog-domain-hosting",
    title: "Domain vs. Hosting: A Simple Guide",
    description: "Confused about domains, hosting, and servers? This guide explains everything in plain English",
    category: "blog",
    url: "/blog/domain-vs-hosting-explained-simple-guide",
    keywords: ["domain", "hosting", "server", "guide", "beginner", "explained", "simple"],
  },
  {
    id: "blog-mistakes",
    title: "5 Website Mistakes Hamptons Businesses Make",
    description: "Common website mistakes and how to fix them for better results",
    category: "blog",
    url: "/blog/5-website-mistakes-hamptons-businesses-make",
    keywords: ["mistakes", "errors", "fix", "slow", "mobile", "seo", "design"],
  },
  {
    id: "blog-pricing",
    title: "How Much Does a Website Cost in the Hamptons?",
    description: "Transparent 2025 pricing guide for web design in the Hamptons area",
    category: "blog",
    url: "/blog/how-much-does-website-cost-hamptons",
    keywords: ["cost", "price", "pricing", "how much", "website cost", "budget", "investment"],
  },
  {
    id: "blog-local-seo",
    title: "Local SEO Tips for Hamptons Small Businesses",
    description: "Learn how to get found by local customers with these SEO strategies",
    category: "blog",
    url: "/blog/local-seo-tips-hamptons-small-business",
    keywords: ["seo", "local", "google", "search", "rankings", "found", "visibility"],
  },

  // FAQs
  {
    id: "faq-edit-website",
    title: "Is it hard to edit my website?",
    description: "No! You'll have access to an AI-powered editor for easy updates",
    category: "faq",
    url: "/how-it-works-web-design-process#faq",
    keywords: ["edit", "update", "change", "modify", "easy", "hard", "difficult"],
  },
  {
    id: "faq-switch-hosting",
    title: "Can I switch hosting options later?",
    description: "Yes! You can upgrade or change your hosting plan anytime",
    category: "faq",
    url: "/how-it-works-web-design-process#faq",
    keywords: ["switch", "change", "hosting", "upgrade", "later", "plan"],
  },
  {
    id: "faq-ownership",
    title: "Do I own my domain and website code?",
    description: "Yes! You own 100% of your domain and all website code",
    category: "faq",
    url: "/how-it-works-web-design-process#faq",
    keywords: ["own", "ownership", "domain", "code", "property", "rights"],
  },
  {
    id: "faq-timeline",
    title: "How long does it take to build a website?",
    description: "Most projects are completed in 1-3 weeks depending on complexity",
    category: "faq",
    url: "/how-it-works-web-design-process#faq",
    keywords: ["time", "long", "timeline", "weeks", "fast", "quick", "duration"],
  },
  {
    id: "faq-existing-domain",
    title: "What if I already have a domain?",
    description: "Yes! I'll connect your existing domain to your new website - you keep full ownership",
    category: "faq",
    url: "/how-it-works-web-design-process#faq",
    keywords: ["existing", "domain", "already", "have", "connect", "transfer"],
  },
  {
    id: "faq-support",
    title: "Do you offer ongoing support?",
    description: "Yes! I'm always available for consultations and support when you need help",
    category: "faq",
    url: "/how-it-works-web-design-process#faq",
    keywords: ["support", "help", "ongoing", "assistance", "after", "launch"],
  },
];

export const searchSite = (query: string): SearchResult[] => {
  if (!query || query.trim().length < 2) return [];

  const searchTerms = query.toLowerCase().trim().split(/\s+/);

  const results = searchIndex
    .map((item) => {
      const searchableText = [
        item.title,
        item.description,
        ...item.keywords,
      ]
        .join(" ")
        .toLowerCase();

      // Calculate relevance score
      let score = 0;
      for (const term of searchTerms) {
        if (item.title.toLowerCase().includes(term)) score += 10;
        if (item.description.toLowerCase().includes(term)) score += 5;
        if (item.keywords.some((k) => k.toLowerCase().includes(term))) score += 3;
        if (searchableText.includes(term)) score += 1;
      }

      return { ...item, score };
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 10);

  return results;
};
